/**
 *  Provides the system specific variables form the Env.
 */

export default class EnvService {
  /*  all REST-Services for security data sheets start at /sdb/
   *  so REST production-url has to be rewritten to /sdb/ by the proxy-server
   *  i.e: /sdb-produktcenter/ to /sdb/
   *  we can't use /sdb/ here as this suburl is already in use for the Javascript application
   */
  static get serviceURLSdb() {
    if (process.env.NODE_ENV === 'production')
      return process.env.VUE_APP_URL
      //return 'https://www.kabe-farben.ch/produktcenter/'
    else
    {
      //local  standalone-deployment
      //return 'http://localhost:8082/sdb/'

      //local  tomcat-deployment
      return process.env.VUE_APP_URL
      //return 'http://172.16.4.63:8087/'
    }
  }

  static get dataTargetEnvironment() {
    const { hostname } = new URL(process.env.VUE_APP_URL);
    if ((hostname=='www.kabe-farben.ch') || (hostname=='testing.kabe-farben.ch'))
      return hostname;
    else
      return "localhost";
  }

  static get isProduction() {
    return process.env.NODE_ENV === 'production' ? true : false;
  }  
}
